import { Inject, Injectable } from '@angular/core';
import { Http, HttpModule, RequestOptions, Headers } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/Rx';
import { Response } from '@angular/http';
import { environment } from '../../../environments/environment';
import { UIService } from './UIService';

declare function $params(obj: any): string;


@Injectable()
export class ServiceCaller {

    http: Http;
    ui: UIService;

    constructor( @Inject(Http) http: Http, @Inject(UIService) ui: UIService) {
        this.http = http;
        this.ui = ui;
    }

    private BaseURL: string = environment.api_url;

    public get(path, body: any = null): Promise<any> {
        var headers = this.createHeader();
        var url = this.BaseURL + path;
        var q = $params(body);
        if (q != "") {
            if (url.indexOf("?") > 0)
                url = url + "&" + q;
            else
                url = url + "?" + q;
        }

        console.log("get=> " + url);
        // 
        //

        return new Promise<any>((resolve, reject) => {
            return this.http.get(url, { headers: headers })
                .toPromise()
                .then(response => {
                    var json = response.json();
                    console.log(json);
                    if (json.Succeed == true)
                        resolve(json.Result);
                    else {
                        let message = json.Message.Handled == true ? json.Message.Text : 'Network Error';
                        this.ui.error(message);
                        reject(message);
                    }
                }).catch(err => {
                    this.ui.error(err);
                    reject(err);
                });;
        });
    }

    public post(path, body: any = null): Promise<any> {
        var headers = this.createHeader();
        //
        return new Promise<any>((resolve, reject) => {
            let url: string = this.BaseURL + path;
            console.log('post=> ' + url);
            this.http.post(url, body, { headers: headers })
                .toPromise()
                .then(response => {
                    var json = response.json();
                    console.log(json);
                    if (json.Succeed == true)
                        resolve(json.Result);
                    else {
                        let message = json.Message.Handled == true ? json.Message.Text : 'Network Error';
                        this.ui.error(message);
                        reject(message);
                    }
                }).catch(err => {
                    this.ui.error(err);
                    reject(err);
                });
        });
    }

    private createHeader(): Headers {
        var headers = new Headers();
        headers.append('Content-Type', 'application/json; charset=utf-8');
        var token = localStorage.getItem("token");
        if (token)
            headers.append("Authorization", "Basic " + localStorage.getItem("token"));
        return headers;
    }
}



// WEBPACK FOOTER //
// D:/Works/Safetyminder/Safetyminder/Admin/src/app/shared/services/ServiceCaller.ts